import { render, staticRenderFns } from "./SQLsErpIntegracao.vue?vue&type=template&id=5affb732&scoped=true"
import script from "./SQLsErpIntegracao.vue?vue&type=script&lang=js"
export * from "./SQLsErpIntegracao.vue?vue&type=script&lang=js"
import style0 from "./SQLsErpIntegracao.vue?vue&type=style&index=0&id=5affb732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5affb732",
  null
  
)

export default component.exports